import { render } from "./ListsPage.vue?vue&type=template&id=8666b80a"
import script from "./ListsPage.vue?vue&type=script&lang=js"
export * from "./ListsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__